var render = function render(_c,_vm){return _c('router-link',{staticClass:"btn",attrs:{"to":_vm.props.to,"aria-label":"Link to next page"}},[_c('span',{staticClass:"btn__stroke"}),_vm._t("default",function(){return [_vm._v("Submit")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }